import React, { Component } from 'react'


class VideoCipherPlayer extends Component {
    constructor(props) {
        super(props);
        this.iframeRef = React.createRef();
    }

    componentDidMount() {
        if (this.iframeRef.current) {
            this.props.setVideoObject(this.iframeRef.current)
        }
    }

    render() {
        const { otp, playbackInfo } = this.props;
        return (
            <div style={{ paddingTop: "56.25%", position: "relative", width: "100%" }}>
                <iframe
                    ref={this.iframeRef}
                    src={`https://player.vdocipher.com/v2/?otp=${otp}&playbackInfo=${playbackInfo}`}
                    style={{
                        border: 0,
                        maxWidth: "100%",
                        position: "absolute",
                        top: 0,
                        left: 0,
                        height: "100%",
                        width: "100%",
                    }}
                    allow="encrypted-media"
                    allowFullScreen
                ></iframe>
            </div>
        )
    }
}

export default VideoCipherPlayer;